import React, { useEffect } from 'react'
import { Button, Form, Row } from 'react-bootstrap'
import ModalCustom from '../../modal-custom'
import { Controller, useForm } from 'react-hook-form'
import DatepickerCustom from '../../datepicker-custom'
import moment from 'moment'
import Error_false from '../../error/error-false'
import SwalCustom from '../../../alert/swal-custom'
import { updateEjipFundAPI } from '../../../services/ejip'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import Autocomplete from '../../custom/autocomplete'
import { TXTSUCCESS } from '../../../Constants'
const schema = yup
  .object({
    fundName: yup.string().required('This is a required question'),
    statusEjip: yup.object().required('This is a required question')
  })
  .required()
export default function ModalEditFund({
  isModalOpenEditMember,
  handleCancelEditMember,
  fnData,
  dataById,
  statusEjip
}) {
  const {
    control,
    setValue,
    setError,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })

  useEffect(() => {
    if (dataById) {
      setValue('fundName', dataById.fund_name)
      setValue('statusEjip', {
        label: dataById.status,
        value: dataById.status_id
      })
      setValue(
        'closeDate',
        dataById.close_date
          ? moment(dataById.close_date).format('YYYY-MM-DD')
          : ''
      )
    }
  }, [dataById, setValue])

  const onSubmitEdit = async (d) => {
    const body = {
      fundId: dataById.id,
      fundName: d.fundName,

      closeDate: d.closeDate,
      statusId: d.statusEjip.value
    }
    const resp = await updateEjipFundAPI(body)
    if (!resp) return
    if (resp.status) {
      SwalCustom({
        title: `Success!`,
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      })
      fnData()
      handleCancelEditMember()
    } else {
      Error_false(resp)
    }
  }

  return (
    <ModalCustom
      open={isModalOpenEditMember}
      centered
      onCancel={handleCancelEditMember}
    >
      <Row>
        <Form onSubmit={handleSubmit(onSubmitEdit)} className="mt-2">
          <div className="col-12 ">
            <div className="fw-normal text-primary"></div>

            <div className="row">
              <div className="fw-normal col-12 pt-1 p-4">
                <div className="p-1"> Fund</div>
                <Controller
                  name={'fundName'}
                  control={control}
                  render={({ field: { value = '', onChange } }) => (
                    <Form.Control value={value} onChange={onChange} />
                  )}
                />
                {errors.fundName?.message && (
                  <label className="small text-danger">
                    {errors.fundName.message}
                  </label>
                )}
              </div>
              <div className="fw-normal col-6 pt-1 p-4">
                <div className="p-1"> Status</div>
                <Controller
                  name={'statusEjip'}
                  control={control}
                  render={({ field: { value = '', onChange } }) => (
                    <Autocomplete
                      value={value}
                      options={statusEjip}
                      onChange={onChange}
                    />
                  )}
                />
                {errors.statusEjip?.message && (
                  <label className="small text-danger">
                    {errors.statusEjip.message}
                  </label>
                )}
              </div>
              <div className="fw-normal col-6 p-4 pt-1">
                <div className="p-1"> Closing Date</div>
                <Controller
                  name={'closeDate'}
                  control={control}
                  render={({ field: { value = '', onChange } }) => (
                    <DatepickerCustom
                      value={value}
                      onChange={([date]) => {
                        setValue(
                          'closeDate',
                          `${date ? moment(date).format('YYYY-MM-DD') : ''}`
                        )
                        setError('closeDate', date)
                      }}
                    />
                  )}
                />
                {errors.closeDate?.message && (
                  <label className="small text-danger">
                    {errors.closeDate.message}
                  </label>
                )}
              </div>
              <div className="col-12 mt-4 d-flex gap-3 justify-content-center">
                <Button
                  variant="outline-primary"
                  style={{
                    width: '130px'
                  }}
                  size="sm"
                  className="rounded-3"
                  onClick={handleCancelEditMember}
                >
                  Cancel
                </Button>

                <Button
                  className="btn btn-primary rounded-3"
                  type="submit"
                  style={{
                    width: '130px'
                  }}
                  size="sm"
                >
                  Apply
                </Button>
              </div>
            </div>
          </div>
        </Form>
      </Row>
    </ModalCustom>
  )
}
